module.exports = __webpack_public_path__ + "static/media/background_1.0e686803.svg";